import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { signIn } from "../api.js";

export function LoginPage({ onSignedIn }: { onSignedIn: () => Promise<void> }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      await signIn(email, password);
      await onSignedIn();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "无法登录，请重试。");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page" id="main-content">
      <section className="auth-panel" aria-labelledby="login-title">
        <div className="auth-brand">
          <span className="brand-tile large-brand">R</span>
          <div>
            <strong>RoleWorth</strong>
            <small>职业机会资料库</small>
          </div>
        </div>
        <div className="auth-copy">
          <p className="eyebrow">静默工作台</p>
          <h1 id="login-title">继续整理值得投入的机会</h1>
          <p>登录你的个人工作区，查看 Agent 保存的职位、评估和历史 JD。</p>
        </div>
        <form className="auth-form" onSubmit={submit}>
          <label>
            邮箱
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
          <label>
            密码
            <input
              type="password"
              autoComplete="current-password"
              required
              minLength={12}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          {error && (
            <p className="form-error" role="alert">
              {error}
            </p>
          )}
          <button className="button primary" type="submit" disabled={busy}>
            {busy ? "正在登录" : "登录"}
          </button>
        </form>
        <p className="auth-note">RoleWorth 只接受邀请注册。需要访问时，请联系管理员。</p>
        <footer>
          <Link to="/privacy">隐私说明</Link>
          <Link to="/terms">使用条款</Link>
        </footer>
      </section>
      <aside className="auth-evidence" aria-label="产品说明">
        <p className="eyebrow">本地 Agent，远程资料库</p>
        <blockquote>“把搜索留在你的电脑，把证据和判断留在一份可追溯的资料库。”</blockquote>
        <dl>
          <div>
            <dt>JD</dt>
            <dd>每次变化都保留快照</dd>
          </div>
          <div>
            <dt>判断</dt>
            <dd>Agent 评估和个人决定分开</dd>
          </div>
          <div>
            <dt>隐私</dt>
            <dd>简历和个人文件不上传</dd>
          </div>
        </dl>
      </aside>
    </main>
  );
}
